import React, { useState, useRef, useEffect } from "react";
import { Button, Icon, Grid } from 'semantic-ui-react';

const VideoDisplay = ({
    currentUrl,
    setSelectedPitch,
    setSelectedInning,
    selectedInning = 0,
    selectedPitch = 0,
    maxPitches,
    maxInnings,
    inningsList,
    setDownInning
}) => {
    // Hook
    function useEventListener(eventName, handler, element = window){
        // Create a ref that stores handler
        const savedHandler = useRef();
    
        // Update ref.current value if handler changes.
        // This allows our effect below to always get latest handler ...
        // ... without us needing to pass it in effect deps array ...
        // ... and potentially cause effect to re-run every render.
        useEffect(() => {
        savedHandler.current = handler;
        }, [handler]);
    
        useEffect(
        () => {
            // Make sure element supports addEventListener
            // On 
            const isSupported = element && element.addEventListener;
            if (!isSupported) return;
    
            // Create event listener that calls handler function stored in ref
            const eventListener = event => savedHandler.current(event);
    
            // Add event listener
            element.addEventListener(eventName, eventListener);
    
            // Remove event listener on cleanup
            return () => {
            element.removeEventListener(eventName, eventListener);
            };
        },
        [eventName, element] // Re-run if eventName or element changes
        );
    };

    const vidRef = useRef(null);
    const handlePlayVideo = () => {
        if(vidRef.current.paused){
            setControls(false);
            vidRef.current.play();
        }
        else {
            setControls(true);
            vidRef.current.pause();
        }
    }

    const [controls, setControls] = useState(true);

    const nextPitch = () => {
        if(selectedPitch < maxPitches)
            setSelectedPitch((current) => current + 1);
        else if(selectedInning < maxInnings){
            setSelectedInning((current) => current + 1);
        }
    }

    const previousPitch = () => {
        if(selectedPitch > 1)
            setSelectedPitch((current) => current - 1);
        else if(selectedInning>1){
            setDownInning(true);
            setSelectedInning((current) => current - 1);
        }
    }

    function handler({ key }) {
        if(String(key) === "k") nextPitch();
        else if(String(key) === "j") previousPitch();
        //else if(String(key) === " ") handlePlayVideo();
    }
    
    useEventListener('keydown', handler);

    return (
        <Grid stretched>
            <Grid.Column width={16}>
                <video 
                    ref={vidRef}
                    controls={controls}
                    autoPlay 
                    onEnded={() => nextPitch()} 
                    src={currentUrl} width="100%" 
                    poster={currentUrl ? null:"https://www.mlbstatic.com/team-logos/league-on-dark/1.svg"}
                />
            </Grid.Column>
        </Grid>
    );
}

export default VideoDisplay;